import { Component, Output, EventEmitter, OnInit, Input } from "@angular/core";
import { FormsModule, ReactiveFormsModule, UntypedFormControl } from '@angular/forms';
import { startWith, map, takeUntil, debounceTime } from 'rxjs/operators';
import { timeZoneOptions, timeZoneOptionsLC } from './timezone-helpers';
import { sleepForMS } from 'src/app/helpers/helpers';
import { Subject } from "rxjs/internal/Subject";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatAutocompleteModule } from "@angular/material/autocomplete";
import { MatOptionModule } from "@angular/material/core";
import { CommonModule } from "@angular/common";

@Component({
    selector: 'timezone-selector',
    templateUrl: './timezone-selector.html',
    styleUrls: ['timezone-selector.scss'],
    standalone: true,
    imports: [MatFormFieldModule, MatAutocompleteModule, MatOptionModule, ReactiveFormsModule, FormsModule, CommonModule]
})
export class TimezoneSelectorComponent  implements OnInit {
  @Input() value:string;
  @Output() onTimezoneChange: EventEmitter<string> = new EventEmitter();
  
  myControl = new UntypedFormControl();
  options: string[] = timeZoneOptions
  filteredOptions: string[]
  debounceTime = 400
  $destroy: Subject<boolean> = new Subject();
  searchKey: Subject<string> = new Subject<string>()
  sleepDelay = 100
  settingByOption = false
  optionOkay = true

  ngOnInit() {
    this.myControl.valueChanges.pipe(debounceTime(this.debounceTime)).pipe(takeUntil(this.$destroy), 
        startWith(''),
        map(value => this._filter(value))
      ).subscribe(filteredOptions => this.filteredOptions = filteredOptions)
    this.myControl.setValue(this.value)
    if (this.value) this.optionOkay = this.options.includes(this.value)
  }
  
  private _filter(value: string): string[] {
    if(!value) return this.options;
    const filterValue = value.toLowerCase();
    return this.options.filter((_, index) => timeZoneOptionsLC[index].includes(filterValue));
  }

  async setTimeZoneDirectly($event) {
    const value = $event.target ? $event.target.value : $event.source.value;
    console.log(`Setting directly called with: ${value}, sleeping first to allow set by option to fire if selected`)
    await sleepForMS(this.sleepDelay) // add a little padding, just in case
    if (this.settingByOption) {
      console.log("Setting by option was selected, not trying to set directly anymore...")
      this.settingByOption = false
      return
    } else {
      console.log("Trying to set directly!")
      this.checkOption(value)
    }
  }

  setAndEmitOption(option: string) {
    // value wasn't updating on way back in
    if (option === this.value) {
      this.myControl.setValue(option)
      console.log("Option is same as before!  Not changing!")
      return
    }
    this.myControl.setValue(option)
    this.optionOkay = true
    this.onTimezoneChange.emit(option)
  }

  checkOption(inputOption: string) {
    const option = inputOption.trim()
    if (this.options.includes(option) || !option) {
      this.setAndEmitOption(option)
    } else if (this.filteredOptions && this.filteredOptions.length === 1) {
      console.log("Selecting top filtered option!")
      this.setAndEmitOption(this.filteredOptions[0])
    } else {
      console.log("OPTION NOT OKAY!")
      this.optionOkay = false
    }
  }

  async setTimezoneByOption(option: string, wasUserSelection: boolean) {
    if (!wasUserSelection) {
      console.log("Deselection of option called at about the same time as selection of option", option)
      return
    }
    this.settingByOption = true
    console.log(`Setting by option called with ${option}!  Should disable next call of setting directly`)
    this.checkOption(option)
  }

}